import axios from 'axios';
import errorobj from '@/assets/api/error';
import router from '@/router';
import store from '@/store';
import { getToken, removeToken } from '@/assets/api/token.js';
import { Message } from 'element-ui';
import { newproxy } from '@/utils/newproxy';
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'http://leyounx.chinananxun.com:3389/gateway',
  timeout: 5000000,
  responseType: 'json',
});
//请求拦截器
service.interceptors.request.use(
  (config) => {
    //拦截请求
    let token = getToken();
    let key = getSiteKey();
    // console.log('key', key);
    // if (token) {
    //   //判断token是否存在
    //   config.headers.Authorization = 'bearer ' + token; //将token设置成请求头
    // }
    if (key != '') {
      config.headers.site_key = key; //site_key
    }

    return config;
  },
  (error) => {
    //出现异常抛出错误
    return Promise.reject(error);
  }
);

//响应拦截器
service.interceptors.response.use(
  (res) => {
    // console.log(res)
    //响应拦截
    if (res.status == 200) {
      // 对响应数据做些事
      //alert("提交成功")
      return Promise.resolve(newproxy(res.data));
    } else {
      Message.error('请求失败，请联系管理员');
    }
    // return res
  },
  (error) => {
    //出现异常抛出错误
    console.log(error.response.data, 'yichang');
    if (error.response.data.resp_code == 401) {
      removeToken(); //删除token
      router.go(-1);
      store.state.dialogVisible = true;
    } else {
      let msg = errorobj[error.response.data.resp_code]
        ? errorobj[error.response.data.resp_code]
        : error.response.data.resp_msg;
      Message.error(msg);
    }
    return Promise.reject(error);
  }
);
//获取站点关键字
function getSiteKey() {
  const siteId = store.state.siteValue;
  const siteList = store.state.siteList;
  let key = '';
  if (siteId) {
    siteList.map((s) => {
      if (s.id == siteId) {
        key = s.keywords;
      }
    });
  }

  return key;
}
export default service; //导出封装好的axios对象
